import React, { Component } from 'react';
import PhoneInput from 'react-phone-number-input/input';
import styled, { css } from 'styled-components';

const StyledPhoneInput = styled(PhoneInput)`
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  padding: 0.375rem 0.75rem;
  ${(props) => props.disabled && css`
    background-color: #FAFAFA;
    border: 1px solid #DEE1EC;
  `}
`;

const StyledPhoneInputV2 = styled(PhoneInput)`
  width: 100% !important;
  height: 40px !important;
  border-radius: 8px !important;
  border: 1px solid #D9D9D9 !important;
  padding: 10px 16px 10px 16px !important;
  outline: none;
  &:hover,
  &:focus {
    box-shadow: none !important;
    border-color: #464D5D !important;
  }
  ${(props) => props.disabled && css`
    background-color: #FAFAFA;
    border: 1px solid #DEE1EC;
  `}
`;

class UsPhoneNumberInput extends Component {
  render() {
    const { value } = this.props;
    const phoneNumber = value ? (value.startsWith('+') ? value : `+${value}`) : value;
    if (window.isOnboardingV2 === 'true') {
      return (
        <StyledPhoneInputV2
          {...this.props}
          value={phoneNumber}
          placeholder="Enter phone number"
          defaultCountry="US"
          international={false}
        />
      );
    }
    return (
      <StyledPhoneInput
        {...this.props}
        placeholder="Enter phone number"
        defaultCountry="US"
        international={false}
      />
    );
  }
}

export default UsPhoneNumberInput;
